export default {
  create: {
    title: 'Add',
    subtitle: 'Cryptogram',
  },
  edit: {
    title: 'Edit',
    subtitle: 'Game',
    button: {
      add: 'New game',
    },
  },
  list: {
    title: 'Cryptograms',
    subtitle: 'List',
    add: 'New game',
  },
  card: {
    title: 'Cryptogram generator',
    actions: 'Actions',
  },
  table: {
    title: 'Active games',
    searchPlaceholder: 'Search...',
  },
  form: {
    name: {
      label: 'Name:',
      invalid: 'Name is required',
    },
    font: {
      label: 'Select font:',
    },
    theme: {
      label: 'Game style:',
      default: 'Default theme',
      radius: 'Rounded',
      molotov: 'Molotov',
    },
    level: {
      label: 'Level:',
    },
    columns: 'Columns:',
    rows: 'Rows:',
    hint: 'Double-click to change the background color.',
  },
  button: {
    fillWords: 'Fill words',
    clearGame: 'Clear game',
    printGame: 'Print game',
    printAnswers: 'Print answers',
    addQuestion: 'Add new question',
    editQuestion: 'Edit question',
  },
  cell: {
    fillWord: 'Fill the rest of the word randomly',
    clearLine: 'Clear line',
  },
  alert: {
    wordCompleted: 'Word completed successfully!',
    cryptogramCleared: 'Cryptogram cleared!',
    wordNotFound: 'No word found!',
    questionAdded: 'Question added successfully!',
    questionDeleted: 'Question deleted successfully!',
    questionEdited: 'Question edited successfully!',
    questionSaveError: 'Error saving the question.',
    questionDeleteError: 'Error deleting the question.',
    sendSuccess: 'Sent successfully',
    sendError: 'Error sending. Please try again.',
  },
};
